import { FieldProps } from 'formik';
import * as React from 'react';
import OnBoardingInput from './shared/OnBoardingInput';
import { InputFieldWidth } from '../types';
import { useDispatch, useSelector } from 'react-redux';
import { makeGetSyncInfo } from 'modules/app/redux/selectors/globalInfo';
import { InfoDetail } from 'modules/app/components/MispAdditionalInfo';
import { syncInfoActions } from 'modules/app/redux/creators/syncInfo';

type Props = {
  error?: string;
  label: string;
  width: InputFieldWidth;
} & FieldProps;

const MispSyncUserMail: React.FunctionComponent<Props> = ({ field, error, form, label, width }: Props) => {
  const dispatch = useDispatch();
  const syncInfo = useSelector(makeGetSyncInfo());

  React.useEffect(() => {
    dispatch(syncInfoActions.getSyncInfo());
  }, []);

  return (
    <React.Fragment>
      <OnBoardingInput type={'text'} {...field} label={label} error={error} width={width} />
      <InfoDetail info={syncInfo || { title: '', content: '' }} active={false} variant="left" />
    </React.Fragment>
  );
};

export default MispSyncUserMail;
